var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90234 9.97266C4.35938 10.3945 5.0625 10.3945 5.51953 9.97266L7.3125 8.17969L9.31641 10.1836C9.52734 10.3945 9.80859 10.5 10.125 10.5C10.4062 10.5 10.6875 10.3945 10.8984 10.1836L16.3125 4.80469C16.7344 4.34766 16.7344 3.64453 16.3125 3.1875C15.8555 2.76562 15.1523 2.76562 14.6953 3.1875L10.125 7.79297L8.08594 5.78906C7.66406 5.33203 6.92578 5.33203 6.50391 5.78906L3.90234 8.35547C3.48047 8.8125 3.48047 9.51562 3.90234 9.97266ZM16.875 13.875H2.25V1.5C2.25 0.902344 1.72266 0.375 1.125 0.375C0.492188 0.375 0 0.902344 0 1.5V15C0 15.6328 0.492188 16.125 1.125 16.125H16.875C17.4727 16.125 18 15.6328 18 15C18 14.4023 17.4727 13.875 16.875 13.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.18c2443e9eb9a76b33fc9884503ee67b.svg";
export { ForwardRef as ReactComponent };